import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from "react-router-dom";
// import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from 'primereact/dropdown';

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';

import brandViewModel from "../../../Brands/Presentation/View/BrandViewModel";
import categoryViewModel from "../../../Categories/Presentation/View/CategoryViewModel";
import colorViewModel from "../../../Colors/Presentation/View/ColorViewModel";
import subCategoryViewModel from "../../../SubCategories/Presentation/View/SubCategoryViewModel";

import { ToggleButton } from 'primereact/togglebutton';
import { Brand } from '../../../Brands/Domain/Model/Brand';
import { Color } from '../../../Colors/Domain/Model/Color';

import { useToast } from '../../../../Shared/hook/useToast';
import productViewModel from "./ProductViewModel";


import { Editor, EditorTextChangeEvent } from "primereact/editor";

import 'quill/dist/quill.snow.css';


export const ProductFormView = ()=> {
    const { id } = useParams(); 
    // const toast = useRef(null);
    const [colorSubmit, setColorSubmit] = useState<string>('dark');
    // const [viewSubCategory, setViewSubCategory] = useState<any[]>([]);
    // const [disabledSelect, setDisabledSelect] = useState<boolean>(true);
    const [checked, setChecked] = useState<boolean>(false);
    const [stateBtn, setStateBtn] = useState<String>("disabled");
    const [precioVenta, setPrecioVenta] = useState<number>(0);
    const [precioDescInput, setPrecioDescInput] = useState<boolean>(true);
    const [percentageDesc, setPercentageDesc] = useState<any>(0);

    const [checkedBankTransferPrice, setCheckedBankTransferPrice] = useState<boolean>(false);
    const [checkedBankTransferPriceDisable, setCheckedBankTransferPriceDisable] = useState<boolean>(false);
    const [bankTransferPriceSt, setBankTransferPriceSt] = useState<any>(0);

    const [checkedYapePrice, setCheckedYapePrice] = useState<boolean>(false); 
    const [checkedYapePriceDisable, setCheckedYapePriceDisable] = useState<boolean>(false); 
    const [yapePriceSt, setYapePriceSt] = useState<any>(0);

    const [status, setStatus] = useState<boolean>(false);
    const [nameAction, setNameAction] = useState("Crear");
    const title=`${nameAction} nuevo Producto`;
    const [viewInUpdate, setViewInUpdate] = useState<boolean>(false);
    
    const navigate = useNavigate();


    const { showSuccess, showError, showWarn, showInfo } = useToast();

    const {
          createProduct,
          getProductById,
          updateProduct,
          } = productViewModel();

    // console.log("getProductById", getProductById);
    const defaultValues = {
        productId: Number(id),
        categoryId: 0,
        subCategoryId: 0,
        brandId: 0,
        colorId: 0,
        productName: '',
        sku: '',
        model: '',
        youtube: '',
        stock: 0,
        salePrice: 0,
        discountPrice: 0,
        bankTransferPrice: 0,
        yapePrice: 0,
        characteristics: '',
        details: '',
        description: '',
        status: 0,
        isDiscount: false,
        isVisibleBankTransferPrice: false,
        isVisibleYapePrice: false,
        // mainImage: 'foto.jpg',
        dateLimitDiscount: new Date(),
        discountPercentage: 0,
        pesoKg: 0,
        largoCm: 0,
        anchoCm: 0,
        altoCm: 0,
    };

    const {
        getCategories,
        categories,
      } = categoryViewModel();

    const {
        getSubCategories,
        viewSubCategory,
        viewSubCategoryList,
        disabledSelect,
    } = subCategoryViewModel();
    const {
        getBrandsList,
        brandsList,
    } = brandViewModel();
    const {
        getColors,
        colors,
    } = colorViewModel();


 
    const fetchProduct = async () => {
        try {
            if(id){
                const  idPro = parseInt(id);
                setNameAction("Editar");
                // setColorbtn("warning");
                 
                 //setPercentageDesc(0);
                const product:any = await getProductById(idPro);
                // console.log("products: ", product);
                 
                if (product) {
                    setStatus(product.status);
                    setChecked(product.isDiscount);
                    setCheckedBankTransferPrice(product.isVisibleBankTransferPrice);
                    setCheckedYapePrice(product.isVisibleYapePrice);
                    // discountPricePercentageInit(product.discountPrice, product);
                    setViewInUpdate(true);
                    setPrecioVenta(product.salePrice);
                    setPrecioDescInput(false);
                    setPercentageDesc(product.discountPercentage);
                    console.log("porcentaje de descuento: ", product.discountPercentage);

                    setBankTransferPriceSt(product.bankTransferPrice);
                    setYapePriceSt(product.yapePrice);
                    
                    const categoryId = product.categoryId;
                    const subCategories =  await viewSubCategoryList(categoryId);

                        reset({
                            productId: Number(id),
                            categoryId: product.categoryId,
                            subCategoryId: product.subCategoryId,
                            brandId: product.brandId,
                            colorId: product.colorId,
                            productName: product.productName,
                            sku: product.sku,
                            model: product.model,
                            youtube: product.youtube,
                            stock: product.stock,
                            salePrice: product.salePrice,
                            discountPrice: product.discountPrice,
                            bankTransferPrice: product.bankTransferPrice,
                            yapePrice: product.yapePrice,
                            characteristics: product.characteristics,
                            details: product.details,
                            description: product.description,
                            status: product.status,
                            isDiscount: product.isDiscount,
                            isVisibleBankTransferPrice: product.isVisibleBankTransferPrice,
                            isVisibleYapePrice: product.isVisibleYapePrice,
                            // mainImage: product.mainImage,
                            dateLimitDiscount: product.dateLimitDiscount,
                            discountPercentage: product.discountPercentage,
                            pesoKg: product.pesoKg ?? 0,
                            largoCm: product.largoCm ?? 0,
                            anchoCm: product.anchoCm ?? 0,
                            altoCm: product.altoCm ?? 0,
                        });
                        renderSubCategories(subCategories, product.subCategoryId, control, disabledSelect);
                       
           
                } else {
                    console.error("Producto no encontrado.");
                }
            }else {
                reset({
                    productId: Number(id),
                    categoryId: 0,
                    subCategoryId: 0,
                    brandId: 0,
                    colorId: 0,
                    productName: '',
                    sku: '',
                    model: '',
                    youtube: '',
                    stock: 0,
                    salePrice: 0,
                    discountPrice: 0,
                    bankTransferPrice:0,
                    yapePrice: 0,
                    characteristics: '',
                    details: '',
                    description: '',
                    status: 0,
                    isDiscount: false,
                    isVisibleBankTransferPrice: false,
                    isVisibleYapePrice: false,
                    // mainImage: 'foto.jpg',
                    dateLimitDiscount: new Date(),
                    discountPercentage: 0,
                    pesoKg: 0,
                    largoCm: 0,
                    anchoCm: 0,
                    altoCm: 0,
                  });
            }
        } catch (error) {
            console.error("Error al obtener el Product", error);
        }
    };

    useEffect(() => {
        getCategories();
        getSubCategories();
        getBrandsList();
        getColors();
        fetchProduct();
        
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [id]);

      useEffect(() => {
       
      }, [precioVenta]);

      useEffect(() => {
        
      }, [precioDescInput]);

    // useEffect(() => {
        
    // }, [bankTransferPriceSt, yapePriceSt]);
    
      useEffect(() => {
        
      }, []);


    const renderHeaderEditor = () => {
    return (
        <span className="ql-formats">
            {/* GRUPO NUEVO: Fuente y Tamaño (lo que falta en tu imagen) */}
            <select className="ql-font" defaultValue="sans-serif">
                <option value="sans-serif">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
            </select>
            <select className="ql-size" defaultValue="normal">
                <option value="small">Pequeño</option>
                <option value="normal">Normal</option>
                <option value="large">Grande</option>
                <option value="huge">Extra Grande</option>
            </select>
            
            {/* Grupo: Estilos básicos */}
            <button className="ql-bold" aria-label="Bold"></button>
            <button className="ql-italic" aria-label="Italic"></button>
            <button className="ql-underline" aria-label="Underline"></button>

            {/* Grupo: Listas (Bullets) */}
            <button className="ql-list" value="ordered" aria-label="Ordered List"></button>
            <button className="ql-list" value="bullet" aria-label="Unordered List"></button>
            
            {/* Grupo: Alineación */}
            <select className="ql-align"></select>

            {/* Grupo: Multimedia */}
            <button className="ql-link" aria-label="Insert Link"></button>
            <button className="ql-image" aria-label="Insert Image"></button>
            <button className="ql-clean" aria-label="Remove Formatting"></button>
        </span>
    );
};
    const headerEditor = renderHeaderEditor();


    const onSubmit = async(
        data: {
            productId: any,
            categoryId: any,
            subCategoryId: any,
            brandId: any,
            colorId: any,
            productName: any,
            sku: any,
            model: any,
            youtube: any,
            stock: any,
            salePrice: any,
            discountPrice: any,
            bankTransferPrice: any,
            yapePrice: any,
            characteristics: any,
            details: any,
            description: any,
            status: any,
            isDiscount: any,
            isVisibleBankTransferPrice: any,
            isVisibleYapePrice: any,
            // mainImage: any,
            dateLimitDiscount: any,
            discountPercentage: any,
            pesoKg: any,
            largoCm: any,
            anchoCm: any,
            altoCm: any,
        }
        ) => {
            
            // console.log(data);
            try {
                
                if(nameAction==="Crear") {
                    const productId = await createProduct(data);
                    // console.log("Producto creado con ID:", productId);
                    if (productId) {
                        showSuccess('Se registro', data.productName);
                        setColorSubmit("success");
                        setTimeout(() => setColorSubmit("dark"), 3000);
                        setStateBtn("");
                        reset();
                        
                        // setProductIdParams(productId);
                        setTimeout(() => {
                            return navigate(`/AddImages/${productId}`, {state: {nombreProducto: data.productName }});
                        }, 4000);
                    } else {
                        showError('La respuesta no tiene el formato esperado o falta el ID del producto.', data.productName);
                    }
                    
                } else if(nameAction==="Editar") {

                    // console.log("Editar");
                   
                    const updateValid:any = await updateProduct(data);
                   
                    if(updateValid===true){
                        
                        showSuccess('Se actualizo', data.productName);
                        setColorSubmit("success");
                        setTimeout(() => setColorSubmit("dark"), 3000);
                        setStateBtn("");
                        setTimeout(() => {
                            return navigate(`/products`);
                        }, 4000);
                        reset({
                            productId: Number(id),
                            categoryId: 0,
                            subCategoryId: 0,
                            brandId: 0,
                            colorId: 0,
                            productName: '',
                            sku: '',
                            model: '',
                            youtube: '',
                            stock: 0,
                            salePrice: 0,
                            discountPrice: 0,
                            bankTransferPrice: 0,
                            yapePrice: 0,
                            characteristics: '',
                            details: '',
                            description: '',
                            status: 0,
                            isDiscount: false,
                            isVisibleBankTransferPrice: false,
                            isVisibleYapePrice: false,
                            // mainImage: 'foto.jpg',
                            dateLimitDiscount: new Date(),
                            discountPercentage: 0,
                            pesoKg: 0,
                            largoCm: 0,
                            anchoCm: 0,
                            altoCm: 0,
                        });
                    } else {
                    showError('Error al actualizar el producto', data.productName);
                    }
                    
                } 
            } catch (error) {
                console.error("Error al crear el producto:", error);
                setColorSubmit("danger"); // Indica visualmente que hubo un error
            }
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        watch 
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const selectedMarcaTemplate = (option: Brand, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const marcaOptionTemplate = (option: Brand) => {
        return (
            <div className="flex align-items-center">
                
                <div>{option.name}</div>
            </div>
        );
    };

    const selectedColorTemplate = (option: Color, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const colorOptionTemplate = (option: Color) => {
        return (
            <div className="flex align-items-center">
                
                <div>{option.name}</div>
            </div>
        );
    }; 


    function discountPricePercentage(descuento: number) {
        
        let percentage = 0;
        let rest = 0;
        
        if(precioVenta>0 && descuento <= precioVenta){
            rest = precioVenta - descuento;
            percentage = descuento>0 ? (rest * 100) / precioVenta : 0;
        }else{
            percentage = 0;
            setValue("discountPrice", 0);
        }
        setPercentageDesc(percentage.toFixed(2));

        
         if(!id){
            setBankTransferPriceSt(descuento);
            setYapePriceSt(descuento);
        }
       
    }
    const renderSubCategories = (
        subCategories: any[],
        selectedSubCategoryId: number,
        control: any,
        disabledSelect: boolean
    ) => {
        return (
            <Controller
                name="subCategoryId"
                control={control}
                rules={{  validate: value => value !== 0 || 'Sub categoría es requerida.' }}
                render={({ field, fieldState }) => (
                    <>
                        <label htmlFor={field.name}>
                            Sub Categoría
                        </label>
                        <Dropdown
                            disabled={disabledSelect}
                            name={field.name}
                            value={field.value || selectedSubCategoryId}
                            focusInputRef={field.ref}
                            onChange={(e) => field.onChange(e.value)}
                            options={subCategories}
                            aria-labelledby={field.name}
                            inputId={field.name}
                            optionLabel="name"
                            optionValue="id"
                            dataKey="id"
                            placeholder="Selecciona una Sub categoría"
                            className={classNames('w-full md:w-14rem', { 'p-invalid': fieldState.invalid })}
                        />
                        {getFormErrorMessage(field.name)}
                    </>
                )}
            />
        );
    };

    return (
        <>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                            <h2>{nameAction} Producto</h2>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/products" className="text-danger">Lista Productos</a>
                                </li>
                                <li className="breadcrumb-item">{nameAction} Producto</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-flex flex-row-reverse">
                                {/* <div className="page_action" >
                                    <Link to={`/AddImages/${productIdParams}`} relative="path" className={`btn btn-dark ${stateBtn}`} > 
                                        <FontAwesomeIcon icon={icon({name: 'plus'})} /> Ingreso de Imágenes
                                    </Link>
                                </div> */}
                                
                                <div className="p-2 d-flex">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className='title-report'>
                    {title}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className="card p-3">
                            
                            <form onSubmit={handleSubmit(onSubmit)} className="text-start">

                                {/* <Toast ref={toast} /> */}
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="d-flex flex-column gap-2 ">
                                            <Controller
                                                name="categoryId"
                                                control={control}
                                                rules={{  validate: value => value !== 0 || 'Categoría es requerida.' }}
                                                render={({ field, fieldState }) => ( 
                                                <>
                                                {/* {console.log('fieldState.invalid:', fieldState.invalid)} */}
                                                    <label htmlFor={field.name}>
                                                        Categoría
                                                    </label>
                                                    <Dropdown name={field.name} value={field.value} focusInputRef={field.ref} aria-labelledby={field.name} inputId={field.name}
                                                    onChange={(e)=>{
                                                        field.onChange(e.value);
                                                        viewSubCategoryList(e.value);
                                                        }
                                                    }
                                                    options={categories} optionLabel="name" optionValue='id' dataKey="id" placeholder="Selecciona una categoría" className={classNames('w-full md:w-14rem', { 'p-invalid': fieldState.invalid })} />
                                                    {getFormErrorMessage(field.name)}
                                                </>
                                            )}
                                            />
                                            {renderSubCategories(viewSubCategory, watch("subCategoryId"), control, disabledSelect)}
                                            <Controller
                                                name="brandId"
                                                control={control}
                                                rules={{  validate: value => value !== 0 || 'Marca es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                <>
                                                    <label htmlFor={field.name}>
                                                        Marca
                                                    </label>
                                                    <Dropdown name={field.name} value={field.value} focusInputRef={field.ref} aria-labelledby={field.name} inputId={field.name}
                                                    onChange={(e) => field.onChange(e.value)} options={brandsList}
                                                    optionLabel="name" optionValue='id' dataKey="id" placeholder="Selecciona una marca" filter valueTemplate={selectedMarcaTemplate} itemTemplate={marcaOptionTemplate} className={classNames('w-full md:w-14rem', { 'p-invalid': fieldState.invalid })} />
                                                    {getFormErrorMessage(field.name)}
                                                </>
                                                
                                            )}
                                            />
                                            <Controller
                                                name="colorId"
                                                control={control}
                                                rules={{ validate: value => value !== 0 || 'Color es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                <>
                                                    <label htmlFor={field.name}>
                                                        Color
                                                    </label>
                                                    <Dropdown name={field.name} value={field.value} focusInputRef={field.ref} aria-labelledby={field.name} inputId={field.name}
                                                    onChange={(e) => field.onChange(e.value)} 
                                                    options={colors} optionLabel="name" optionValue='id' dataKey="id" placeholder="Selecciona una color" filter valueTemplate={selectedColorTemplate} itemTemplate={colorOptionTemplate} className={classNames('w-full md:w-14rem', { 'p-invalid': fieldState.invalid })} />
                                                    {getFormErrorMessage(field.name)}
                                                </>
                                                
                                            )}
                                            />
                                            <Controller
                                                name="productName"
                                                control={control}
                                                rules={{ required: 'Nombre es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                     {/* {console.log('fieldState.invalid productName:', fieldState.invalid)} */}
                                                        <label htmlFor={field.name}>
                                                            Nombre
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.invalid })} />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                            <Controller
                                                name="sku"
                                                control={control}
                                                rules={{ required: 'SKU es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            SKU
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                            <Controller
                                                name="model"
                                                control={control}
                                                rules={{ required: 'Modelo es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Modelo
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.error })} />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                            <Controller
                                                name="youtube"
                                                control={control}
                                                rules={{  }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Youtube 
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} 
                                                        // className={classNames({ 'p-invalid': fieldState.error })} 
                                                        />
                                                        {/* {getFormErrorMessage(field.name)} */}
                                                    </>
                                                )}
                                                
                                            />
                                            <Controller
                                                name="stock"
                                                control={control}
                                                rules={{ validate: value => value !== 0 || 'Stock es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Stock
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value.toString()}  onChange={(e) => field.onChange(e.target.value)} 
                                                        className={classNames({ 'p-invalid': fieldState.error })} 
                                                        />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                            <section className="section-physical-product-characteristics">
                                                <article className="physical-product-characteristics-item col-lg-3">
                                                    <Controller
                                                        name="pesoKg"
                                                        control={control}
                                                        rules={{ }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Peso (kg)
                                                                </label>
                                                                <InputText  id={field.name} name={field.name} value={field.value?.toString()  ?? null}  onChange={(e) => field.onChange(e.target.value)} 
                                                                // className={classNames({ 'p-invalid': fieldState.error })} 
                                                                />
                                                                {/* {getFormErrorMessage(field.name)} */}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                </article>
                                                <article className="physical-product-characteristics-item col-lg-3">
                                                    <Controller
                                                        name="largoCm"
                                                        control={control}
                                                        rules={{ }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Largo (cm)
                                                                </label>
                                                                <InputText  id={field.name} name={field.name} value={field.value?.toString()  ?? ""}  onChange={(e) => field.onChange(e.target.value)} 
                                                                // className={classNames({ 'p-invalid': fieldState.error })} 
                                                                />
                                                                {/* {getFormErrorMessage(field.name)} */}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                </article>
                                                <article className="physical-product-characteristics-item col-lg-3">
                                                    <Controller
                                                        name="anchoCm"
                                                        control={control}
                                                        rules={{ }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Ancho (cm)
                                                                </label>
                                                                <InputText  id={field.name} name={field.name} value={field.value.toString()  ?? ""}  onChange={(e) => field.onChange(e.target.value)} 
                                                                // className={classNames({ 'p-invalid': fieldState.error })} 
                                                                />
                                                                {/* {getFormErrorMessage(field.name)} */}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                </article>
                                                <article className="physical-product-characteristics-item col-lg-3">
                                                    <Controller
                                                        name="altoCm"
                                                        control={control}
                                                        rules={{ }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Alto (cm)
                                                                </label>
                                                                <InputText  id={field.name} name={field.name} value={field.value?.toString()  ?? ""}  onChange={(e) => field.onChange(e.target.value)} 
                                                                // className={classNames({ 'p-invalid': fieldState.error })} 
                                                                />
                                                                {/* {getFormErrorMessage(field.name)} */}
                                                            </>
                                                        )}
                                                    />
                                                </article>
                                            </section>
                                            
                                            <Controller
                                                name="salePrice"
                                                control={control}
                                                rules={{ validate: value => value !== 0 || 'Precio venta es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Precio venta 
                                                        </label>
                                                        <InputText  id={field.name} name={field.name} value={field.value.toString()}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            field.onChange(e.target.value);
                                                             setPrecioVenta(Number(e.target.value));
                                                             if(Number(value)>0){
                                                                 setPrecioDescInput(false);  
                                                             }else{
                                                                 setPrecioDescInput(true);
                                                                 setValue("discountPrice", 0);
                                                                 setPercentageDesc(0);
                                                             }
                                                             setValue("discountPrice", 0);
                                                             setPercentageDesc(0);

                                                        }}
                                                        className={classNames({ 'p-invalid': fieldState.error })} />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                             <div className="flex align-items-center">
                                             <Controller
                                              name="isDiscount"
                                              control={control}
                                              rules={{ }}
                                              render={({ field, fieldState }) => (
                                                        <label className="ml-2">
                                                            <Checkbox 
                                                            id={field.name} 
                                                            name={field.name} 
                                                            value={field.value}
                                                            onChange={(e) => {
                                                                field.onChange(e.target.checked);
                                                                setChecked(!checked);
                                                            }} 
                                                            checked={checked}>

                                                            </Checkbox>
                                                            &nbsp;&nbsp;Marca la casilla si hay descuento
                                                        </label>
                                                    )}
                                                />
                                            </div>
                                            {checked && (
                                                <>
                                                    <div className="d-flex justify-content-between">
                                                        <div className="col-lg-7 d-flex flex-column">
                                                            <Controller
                                                                name="discountPrice"
                                                                control={control}
                                                                rules={{ validate: value => value !== 0 || 'Precio Descuento es requerido.' }}
                                                                render={({ field, fieldState }) => (
                                                                    <>
                                                                        <label htmlFor={field.name}>
                                                                            Precio descuento 
                                                                        </label>
                                                                        <div className="p-inputgroup flex-1">
                                                                            <span className="p-inputgroup-addon">
                                                                                S/
                                                                            </span>
                                                                            <InputText disabled={precioDescInput}  id={field.name} name={field.name} value={field.value.toString()}
                                                                            onChange={(e) => {
                                                                                field.onChange(e.target.value);
                                                                                discountPricePercentage(Number(e.target.value));
                                                                            }} 
                                                                            className={classNames({ 'p-invalid': fieldState.error })} />
                                                                        </div>
                                                                        {getFormErrorMessage(field.name)}
                                                                    </>
                                                                )}
                                                                
                                                            />
                                                        </div>
                                                        <div className="col-lg-4 d-flex  flex-column">
                                                            
                                                            <label>
                                                                Nivel de porcentaje <span className='text-danger'>(Generado)</span>
                                                            </label>
                                                            <div className="p-inputgroup flex-1">
                                                                <InputText disabled  value={percentageDesc}  />
                                                                <span className="p-inputgroup-addon">
                                                                    %
                                                                </span>
                                                            </div>
                                                              
                                                        </div>
                                                    </div>
                                                    
                                                    <Controller
                                                        name="dateLimitDiscount"
                                                        control={control}
                                                        rules={{ required: 'Fecha límite es requerido.' }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Fecha límite
                                                                </label>
                                                                <Calendar name={field.name} value={field.value} aria-labelledby={field.name} inputId={field.name}
                                                                onChange={(e) => field.onChange(e.value)} dateFormat="dd/mm/yy" className={classNames({ 'p-invalid': fieldState.error })} />
                                                                {getFormErrorMessage(field.name)}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                    <Controller
                                                        name="bankTransferPrice"
                                                        control={control}
                                                        rules={{ required: 'Precio tranferencia o depósito es requerido.' }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                   Precio tranferencia o depósito
                                                                </label>
                                                                {checkedBankTransferPrice &&(
                                                                    <>
                                                                      <p className="m-0 text-success text-right">Precio de transferencia o depósito visible</p>
                                                                    </>
                                                                )}
                                                                <div className="p-inputgroup flex-1">
                                                                {viewInUpdate && (
                                                                    <Controller
                                                                    name="isVisibleBankTransferPrice"
                                                                    control={control}
                                                                    rules={{ }}
                                                                    render={({ field, fieldState }) => (
                                                                             <>
                                                                                <span className="p-inputgroup-addon">
                                                                                    <Checkbox disabled={checkedBankTransferPriceDisable} id={field.name} name={field.name}  checked={checkedBankTransferPrice} value={field.value.toString()}
                                                                                              onChange={(e) => {
                                                                                              field.onChange(e.target.checked);
                                                                                              setCheckedBankTransferPrice(!checkedBankTransferPrice);
                                                                                    }} 
                                                                                    />
                                                                                </span>
                                                                             </>
                                                                          )}
                                                                      />
                                                                   
                                                                )}
                                                                    <InputText  id={field.name} name={field.name} value={bankTransferPriceSt}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        field.onChange(e.target.value);
                                                                        setBankTransferPriceSt(e.target.value);
                                                                         
                                                                        //Number(value)>0 ? uncheck : setCheckedBankTransferPriceDisable(true);
                                                                        if(Number(value)>0){
                                                                            setCheckedBankTransferPriceDisable(false);
                                                                        }else{
                                                                           setCheckedBankTransferPriceDisable(true);
                                                                           setCheckedBankTransferPrice(false);
                                                                        }
                                                                    }} 
                                                                    className={classNames({ 'p-invalid': fieldState.error })} />
                                                                </div>
                                                                {getFormErrorMessage(field.name)}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                    
                                                    <Controller
                                                        name="yapePrice"
                                                        control={control}
                                                        rules={{ required: 'Precio Yape es requerido.' }}
                                                        render={({ field, fieldState }) => (
                                                            <>
                                                                <label htmlFor={field.name}>
                                                                    Precio yape 
                                                                </label>
                                                                {checkedYapePrice &&(
                                                                    <>
                                                                      <p className="m-0 text-success text-right">Precio de Yape visible</p>
                                                                    </>
                                                                )}
                                                                
                                                                <div className="p-inputgroup flex-1">
                                                                    {viewInUpdate && (
                                                                        <Controller
                                                                        name="isVisibleYapePrice"
                                                                        control={control}
                                                                        rules={{ }}
                                                                        render={({ field, fieldState }) => (
                                                                                 <>
                                                                                    <span className="p-inputgroup-addon">
                                                                                        <Checkbox disabled={checkedYapePriceDisable}  id={field.name} name={field.name} checked={checkedYapePrice} value={field.value.toString()}
                                                                                        onChange={(e) => {
                                                                                            field.onChange(e.target.checked);
                                                                                            setCheckedYapePrice(!checkedYapePrice);
                                                                                        }} />
                                                                                    </span>
                                                                                 </>
                                                                              )}
                                                                          />
                                                                        
                                                                    )}
                                                                    
                                                                    <InputText  id={field.name} name={field.name} value={yapePriceSt}  
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        field.onChange(e.target.value);
                                                                        setYapePriceSt(e.target.value);
                                                                         //Number(value)>0 ? setCheckedYapePriceDisable(false) : setCheckedYapePriceDisable(true);
                                                                         if(Number(value)>0){
                                                                            setCheckedYapePriceDisable(false);
                                                                         }else{
                                                                            setCheckedYapePriceDisable(true);
                                                                            setCheckedYapePrice(false);
                                                                         }
                                                                    }} 
                                                                    className={classNames({ 'p-invalid': fieldState.error })} />
                                                                </div>
                                                                {getFormErrorMessage(field.name)}
                                                            </>
                                                        )}
                                                        
                                                    />
                                                      
                                                    
 
                                                </>
                                            )}
                                            <Controller
                                                name="status"
                                                control={control}
                                                rules={{  }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            
                                                        </label>
                                                        
                                                        <div className="card flex justify-content-center">
                                                            <ToggleButton onLabel="Mostrar en tienda" offLabel="No mostrar" onIcon="pi pi-check" offIcon="pi pi-times" aria-labelledby={field.name} id={field.name}
                                                                checked={status} onChange={
                                                                    (e) => {setStatus(e.value);
                                                                        const st = e.target.value ? 0 : 1;
                                                                        field.onChange(st);
                                                                    

                                                             }} className="w-9rem" />
                                                        </div>
                                                        
                                                    </>
                                                )}
                                                
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex flex-column gap-2 ">
                                            <Controller
                                                name="characteristics"
                                                control={control}
                                                rules={{ validate: value => value !== '' || 'Características es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Características 
                                                        </label>
                                                        <Editor headerTemplate={headerEditor} id={field.name} name={field.name} value={field.value} aria-labelledby={field.name}
                                                        onTextChange={(e: EditorTextChangeEvent) => field.onChange(e.htmlValue)} style={{ height: '250px' }} 
                                                        className={classNames({ 'p-invalid': fieldState.invalid })}
                                                        // headerTemplate={headerTemplate} modules={{ toolbar: fullToolbarWithoutImage }}
                                                        />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                                
                                            />
                                            <Controller
                                                name="details"
                                                control={control}
                                                rules={{ validate: value => value !== '' || 'Detalle del producto es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Detalle del producto 
                                                        </label>
                                                        <Editor headerTemplate={headerEditor} id={field.name} name={field.name} value={field.value} aria-labelledby={field.name}
                                                        onTextChange={(e:EditorTextChangeEvent) => field.onChange(e.htmlValue)} style={{ height: '450px' }} 
                                                        className={classNames({ 'p-invalid': fieldState.invalid })} 
                                                        // headerTemplate={headerTemplate} modules={{ toolbar: fullToolbarWithoutImage }}
                                                        />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                            />
                                            <Controller
                                                name="description"
                                                control={control}
                                                rules={{ validate: value => value !== '' || 'Descripción es requerido.' }}
                                                render={({ field, fieldState }) => (
                                                    <>
                                                        <label htmlFor={field.name}>
                                                            Descripción
                                                        </label>
                                                        <Editor headerTemplate={headerEditor} id={field.name} name={field.name} value={field.value} aria-labelledby={field.name}
                                                        onTextChange={(e: EditorTextChangeEvent) => field.onChange(e.htmlValue)} style={{ height: '450px' }} 
                                                        className={classNames({ 'p-invalid': fieldState.invalid })} 
                                                        // headerTemplate={headerTemplate} modules={{ toolbar: fullToolbarWithoutImage }}
                                                        />
                                                        {getFormErrorMessage(field.name)}
                                                    </>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-float-content">
                                    <Button label="Guardar" type="submit" icon="pi pi-check" className={"btn btn-"+colorSubmit} />  
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
